import React from "react"
import PropTypes from "prop-types"

const SearchIcon = ({ style }) => (
  <svg style={style} viewBox="0 0 20 20">
    <path d="M19.9 18.9l-5.3-5.3c1.2-1.4 2-3.3 2-5.3 0-4.6-3.7-8.3-8.3-8.3S0 3.7 0 8.3s3.7 8.3 8.3 8.3c2 0 3.9-.7 5.3-2l5.3 5.3c.2.2.5.2.7 0l.3-.3c.1-.2.1-.5 0-.7zM1.4 8.3c0-3.8 3.1-6.9 6.9-6.9s6.9 3.1 6.9 6.9-3.1 6.9-6.9 6.9-6.9-3.1-6.9-6.9z" />
  </svg>
)

SearchIcon.propTypes = {
  style: PropTypes.object
}

export default SearchIcon



// WEBPACK FOOTER //
// ./src/components/icons/search-icon.jsx